module.exports = __webpack_public_path__ + "img/d-step2.3244296d.png";